module.exports = __webpack_public_path__ + "img/details_arrow.3f66cad2.svg";